/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Components */
import AddToCartButton from './components/AddToCartButton';

const addToCartNodes = Array.from(document.querySelectorAll('[data-add-to-cart]'));
if (addToCartNodes.length) {
    addToCartNodes.forEach((node) => {
        render(
            <AddToCartButton
                {...(JSON.parse(node.dataset.addToCart || '{}'))}
                shopwareUrl={node.dataset.shopwareUrl}
                relatedProductsUrl={node.dataset.relatedProductsUrl}
                contentBlockProductsUrl={node.dataset.contentBlockProductsUrl}
                redirectUrl={node.dataset.redirectUrl}
            />,
            node
        );
    });
}
